import { useCallback, useRef } from "react";
import { useShareSession } from "@jari-tools/shared";
import { getAdventures, getAdventure } from "../content";
import type { GameSummary } from "../types/adventure";
import { Game } from "./Game";
import "../tool.css";

const ADVENTURES = getAdventures();

export function SharePlayApp() {
  const { cfg, submitResult, submitError, submitting } = useShareSession();
  const lastSummaryRef = useRef<GameSummary | null>(null);
  const submittedRef = useRef(false);

  const adventureId =
    typeof cfg?.adventureId === "string" ? cfg.adventureId : "ruimtereis";

  const sendResult = useCallback(
    async (summary: GameSummary) => {
      lastSummaryRef.current = summary;
      if (submittedRef.current) return;
      submittedRef.current = true;
      try {
        await submitResult({
          completed: true,
          resultType: "act-avontuur",
          data: {
            adventureId: summary.adventureId,
            adventureLabel: summary.adventureLabel,
            summary,
          },
        });
      } catch {
        submittedRef.current = false;
      }
    },
    [submitResult],
  );

  const adventure = getAdventure(adventureId);
  if (!adventure) {
    return (
      <main className="act-share-play">
        <p>Dit avontuur is niet beschikbaar.</p>
      </main>
    );
  }

  return (
    <main className="act-share-play">
      <div className="act-share-play__frame">
        <Game
          adventures={ADVENTURES}
          isPaid
          forcedAdventureId={adventureId}
          shareMode
          onPaywall={() => {}}
          onReachSummary={sendResult}
        />
      </div>
      {submitting ? (
        <p className="act-share-play__status" role="status">
          Resultaat verzenden…
        </p>
      ) : null}
      {submitError ? (
        <div className="act-share-play__error" role="alert">
          <p>Kan resultaat niet verzenden, probeer opnieuw.</p>
          <button
            type="button"
            className="jari-btn jari-btn--primary"
            onClick={() => {
              if (lastSummaryRef.current) {
                void sendResult(lastSummaryRef.current);
              }
            }}
            disabled={submitting || !lastSummaryRef.current}
          >
            Opnieuw proberen
          </button>
        </div>
      ) : null}
    </main>
  );
}
